// 详情面板
import type { FileItem } from '../lib/db';
import { formatBytes, formatDate, formatDuration, isImage, isVideo, isAudio } from '../lib/utils';
import { makeT, type Lang } from '../lib/i18n';

export function DetailPanel({ item, lang, onClose, onDelete }: {
  item: FileItem;
  lang: Lang;
  onClose: () => void;
  onDelete: (item: FileItem) => void;
}) {
  const t = makeT(lang);
  const isImg = isImage(item.mime);
  const isVid = isVideo(item.mime);
  const isAud = isAudio(item.mime);

  const rows: { k: string; v: string }[] = [];
  if (item.width && item.height) rows.push({ k: t('detail.res'), v: item.width + ' × ' + item.height });
  if (item.takenAt) rows.push({ k: t('detail.takenAt'), v: formatDate(item.takenAt, lang) });
  if (isVid && item.duration) rows.push({ k: t('detail.duration'), v: formatDuration(item.duration) });
  rows.push({ k: t('detail.format'), v: item.mime || '-' });
  rows.push({ k: t('detail.size'), v: formatBytes(item.size) });
  rows.push({ k: t('detail.uploadedAt'), v: formatDate(item.uploadedAt, lang) });

  return (
    <div className="detail-panel">
      <button className="close" onClick={onClose}>×</button>
      <h3>{item.displayName}</h3>
      {rows.map((r) => (
        <div className="row" key={r.k}><span className="k">{r.k}</span><span className="v">{r.v}</span></div>
      ))}
      <div className="actions">
        <a href={'/api/files/' + item.uuid + '/download'} download={item.displayName}>{t('ops.download')}</a>
        <button onClick={() => onDelete(item)}>{t('ops.delete')}</button>
      </div>
    </div>
  );
}
